import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Atalhos logo abaixo do título: um chip por case e por tema (no celular, uma linha com rolagem lateral).
export default function CasesNav({ links }: { links: { id: string; label: string }[] }) {
  const { t } = useTranslation();

  return (
    <nav className="cz-cases-nav" aria-label={t("cases_page.labels.nav_label", "Navegue pelos cases")}>
      <ul className="cz-cases-nav__list">
        {links.map(({ id, label }) => (
          <li key={id}>
            <Link to={`#${id}`} className="cz-cases-nav__link">
              {label}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}
